module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100vh",
      "background": "url(https://ccago.oss-cn-hangzhou.aliyuncs.com/bg-award-jys.jpg) no-repeat",
      "background-size": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "background": "rgba(255,255,255,0.74)",
      "border": "10px solid rgba(164,208,255,0.43)",
      "border-radius": "20px",
      "margin-left": "20px",
      "margin-right": "20px",
      "height": "100px",
      "letter-spacing": "0.2em",
      "text-shadow": "2px 2px 0 white, -2px -2px 0 white, 2px -2px 0 white, -2px 2px 0 white",
      "line-height": "100px",
      "margin-bottom": "10px",
      "text-align": "center",
      "color": "#000",
      "font-size": "48px",
      "padding": "0px 20px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.start.subject_name))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "height": "auto",
      "line-height": "140px",
      "margin": "10px",
      "color": "#ca9a9a",
      "font-size": "80px",
      "padding": "0",
      "text-shadow": "2px 2px 0 white, -2px -2px 0 white, 2px -2px 0 white, -2px 2px 0 white",
      "font-weight": "bold"
    }
  }, [_vm._v(" \n    " + _vm._s(_vm.start.mingcheng))]), _vm._v(" "), _c('div', {
    staticClass: "machine-box",
    staticStyle: {
      "margin": "10px",
      "height": "100%"
    },
    style: ({
      'color': _vm.row.show_font_color
    })
  }, [_c('div', {
    staticClass: "machine-content"
  }, [_c('table', {
    staticClass: "machine-table",
    style: ({
      'color': _vm.row.show_font_color_2
    })
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "background-image": "linear-gradient(180deg, #E04063 0%, #B71C3E 48%, #E04063 100%)",
      "border-radius": "10px",
      "color": "#ffffffcc"
    }
  }, [_vm._v(_vm._s(_vm.start.rank))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "background-image": "linear-gradient(180deg, #09BA83 0%, #007650 48%, #09BA83 100%)",
      "border-radius": "10px",
      "color": "#ffffffcc"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.start.score_total) + "\n              ")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticStyle: {
      "color": "#ca9a9a",
      "text-shadow": "2px 2px 0 white, -2px -2px 0 white, 2px -2px 0 white, -2px 2px 0 white"
    }
  }, [_c('th', [_vm._v("排名")]), _vm._v(" "), _c('th', [_vm._v("总分")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f627270","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/score/ScoreAwardOne.vue
// module id = 2212
// module chunks = 0